import { Typography } from '@occc-app/design-system';

import { noDataMessage } from '../retailer-connect.copies';

export const RetailerNetworkNoData = () => {
  return (
    <Typography color='error' align='center' mt={16} data-testid='no-data-msg'>
      {noDataMessage}
    </Typography>
  );
};
